import * as HttpApiSchema from "@effect/platform/HttpApiSchema";
import {Schema} from "effect";

export const FollowWriteOperation = Schema.Literal("follow", "unfollow");
export type FollowWriteOperation = typeof FollowWriteOperation.Type;

export class FollowWriteError extends Schema.TaggedError<FollowWriteError>()(
    "FollowWriteError",
    {
        operation: FollowWriteOperation,
        accountUid: Schema.String,
        reason: Schema.String,
    },
    HttpApiSchema.annotations({status: 500}),
) {}

export class FollowAuthError extends Schema.TaggedError<FollowAuthError>()(
    "FollowAuthError",
    {
        reason: Schema.String,
    },
    HttpApiSchema.annotations({status: 401}),
) {}

export type FollowError = FollowWriteError | FollowAuthError;
